import { Component } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { TAndCModal } from '../../../modals/tandc-modal/tandc-modal.component';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { Observable, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'app-activate-e-wallet',
  templateUrl: './activate-e-wallet.component.html',
  styleUrls: ['./activate-e-wallet.component.scss'],
})
export class ActivateEWalletComponent {
  nairaChecked = false;
  dollarChecked = false;
  agreementAccepted = false;
  filter: AppFilter = new AppFilter();
  baseUrl = environment.API_SERVER;
  pending: boolean;
  success: any;
  error: any;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  currencies;
  organization;
  user: any;
  constructor(
    private router: Router,
    // private AolService: AolService,
    private modalService: SuiModalService,
    private location: Location,
    private walletService: EwalletService
  ) {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.user['totpEnabled']
      ? this.getCurrency(1)
      : this.router.navigate(['/contractor/wallet']);
    this.filter = new AppFilter({
      rows: 1000000,
      _search: false,
    });
  }

  goBack() {
    this.location.back();
  }

  // get page request organization with filter params
  getCurrency(page: number) {
    this.filter.page = page;
    this.pending = true;
    this.error = null;
    this.walletService
      .getCurrencies({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.currentPage = this.filter.page;
          this.currencies = res.rows;
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  onCheckboxChange(row: any) {
    if (row.checked) {
      this.getAllBanks(row.currencyLongName.toLowerCase(), row);
    }
  }
  getAllBanks(currency, row) {
    this.pending = true;
    this.error = null;
    this.walletService
      .getBanks({
        currency: currency,
      })
      .subscribe(
        (res: any) => {
          row.banks = res; // Save the banks in the row object
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }

  activateCurrrency(payload): Observable<any> {
    this.pending = true;
    this.error = null;

    return this.walletService.activateCurrency({ body: payload }).pipe(
      map((res: any) => {
        this.success = 'Currency Successfully activated';
        this.pending = false;
        return res; // Pass the response through
      }),
      catchError((error) => {
        this.pending = false;
        this.error = error.error;
        throw error; // Rethrow the error to be caught by the calling code
      })
    );
  }
  activateWallet() {
    console.log(this.currencies, 'currencies');
    this.modalService
      .open(
        new ConfirmModal(
          'Activate eWallet?',
          'Are you sure you want to activate the selected eWallet currency account?',
          ModalSize.Tiny,
          'Yes, activate',
          'Cancel'
        )
      )
      .onApprove(() => {
        // this.walletServices.activate();
        this.goToActivateWallet();
        // this.router.navigate(['/contractor/wallet/accounts']);
      })
      .onDeny(() => {});
  }

  async processObjects(checkedObjects): Promise<void> {
    const observables = checkedObjects
      .map((item) => {
        let body;
        if (item.currencyLongName.includes('DOLLAR')) {
          body = {
            nccId: this.organization.jpaContractor.nccId,
            currencyId: item.currencyId,
            // accountDetails: {
            //   bankName: item.selectedBank,
            //   bankAccountName: item.accountName,
            //   bankAccountNumber: item.accountNumber,
            //   routingNumber: item.ibanNumber ? item.ibanNumber : '',
            //   sortCode: item.sortCode ? item.sortCode : '',
            //   intermediarySortCode: item.intermediaryBankSwiftCode
            //     ? item.intermediaryBankSwiftCode
            //     : '',
            //   bankPhysicalAddress: item.bankAddress ? item.bankAddress : '',
            // },
          };
        } else {
          body = {
            nccId: this.organization.jpaContractor.nccId,
            currencyId: item.currencyId,
            // accountDetails: {
            //   bankId: item.selectedBank.optionId,
            //   bankName: item.selectedBank.optionName,
            //   bankAccountName: item.accountName,
            //   bankAccountNumber: item.accountNumber,
            // },
          };
        }
        const observable = this.activateCurrrency(body);
        return observable;
      })
      .filter((observable) => observable !== undefined);

    try {
      if (observables.length === 0) {
        console.log('No valid observables to process.');
        return;
      }

      if (observables.length === 1) {
        // If there is only one observable, navigate immediately
        await observables[0].toPromise();
        console.log('Activation completed successfully!');
      } else {
        // If there are multiple observables, wait for all to complete
        await forkJoin(observables).toPromise();
        console.log('All activations completed successfully!');
      }
      this.success = 'Company Wallet Activated successfull';
      setTimeout(() => {
        this.router.navigate(['/contractor/wallet/accounts']);
      }, 2000);
    } catch (error) {
      console.error('An error occurred during activation:', error);
      this.error = error.error;
      // Handle errors if needed
    }
  }
  goToActivateWallet() {
    this.pending = true;
    const user = JSON.parse(localStorage.getItem('user'));
    const nccId = user.organizationId.jpaContractor.nccId;
    this.walletService
      .activateCompany({
        body: {
          nccId: nccId,
        },
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          const checkedObjects = this.currencies.filter((obj) => obj.checked);
          this.processObjects(checkedObjects);
        },
        (err) => {
          this.error = err.error.message;
          this.pending = false;
        }
      );
  }
  areConditionsMetForObjects(arrayOfObjects: any[]): boolean {
    const checkedObjects = arrayOfObjects?.filter((obj) => obj.checked);

    if (!checkedObjects || checkedObjects?.length === 0) {
      return false;
    }

    return true;
    // const areConditionsMet = checkedObjects.every((obj) => {
    //   if (obj.currencyLongName.includes('DOLLAR')) {
    //     return obj?.accountName && obj?.accountNumber && obj?.selectedBank;
    //   } else {
    //     return obj?.accountName && obj?.accountNumber && obj?.selectedBank;
    //   }
    // });
    // return areConditionsMet;
  }
  transformString(input: string): string {
    return (
      input.toLowerCase().charAt(0).toUpperCase() + input.slice(1).toLowerCase()
    );
  }
  openTandC(e) {
    e.stopPropagation();
    this.modalService
      .open(new TAndCModal('', ModalSize.Large))
      .onApprove((value: any) => {
        this.agreementAccepted = true;
      })
      .onDeny(() => {
        this.agreementAccepted = false;
      });
  }
}
